import $ from 'cash-dom';

class ProgressBar {
	constructor(selector) {
		const $progressbarHolder = $(selector);

		if (!$progressbarHolder) {
			return null;
		}

		this._$progress = $progressbarHolder.find('.progress-bar');
		this._$progressPercantage = $progressbarHolder.find('.progress-bar-percantage')
		this._progressInterval = null;
		this._currentProgress = 0;
		this._progressTextInterval = null;
		this._$progressTextLines = $progressbarHolder.find('.progress-bar-info-holder .line');
	}

	_start() {
		this._currentProgress = 0;

		this._progressInterval = setInterval(() => {
			if (this._currentProgress >= 100) {
				this._clearProgressInterval();
			} else {
				this._currentProgress += 1;
				this._$progress.css('width', this._currentProgress + '%');
				this._$progressPercantage.text(this._currentProgress + '%');

				if (this._currentProgress === 7) {
					this._$progress.css('border-radius', '24px');
				}
			}
		}, 100);

		this.progressTextIndex = 0;
		this._progressTextInterval = setInterval(() => {
			this._$progressTextLines.each(function () {
				$(this).removeClass('active');
			});

			const $currentLine = this._$progressTextLines.eq(this.progressTextIndex);
			$currentLine.addClass('active');

			this.progressTextIndex = (this.progressTextIndex + 1) % this._$progressTextLines.length;
		}, 2000);

		this._$progressTextLines.each(function () {
			$(this).removeClass('active');
		});
		if (this._$progressTextLines.length > 0) {
			this._$progressTextLines.eq(0).addClass('active');
		}
	}

	_finish() {
		this._clearProgressInterval();

		if (this._isProgressFinished()) {
			return;
		}

		const progress = 100;
		this._$progress.css('width', progress + '%');
		this._$progressPercantage.text(progress + '%');
	}

	_isProgressFinished() {
		return this._currentProgress >= 100;
	}

	_clearProgressInterval() {
		if (this._progressInterval) {
			clearInterval(this._progressInterval);
		}
	}
}

export default ProgressBar;